import { cva } from "class-variance-authority"

export const cardLayoutCva = cva(["grid", "h-max", "w-full", "gap-2", "grid-cols-1", "md:grid-cols-2"])

export const ringCva = cva(["ring-1"], {
	variants: {
		alpha: {
			true: ["ring-(--base-a6)"],
			false: ["ring-(--base-6)"],
		},
	},
})
